import { Flex, FlexProps } from "@chakra-ui/react";
import NextNProgress from "nextjs-progressbar";
import Header from "components/Header";
import Footer from "components/Footer";

interface LayoutProps extends FlexProps {
  children: React.ReactNode;
}

const Layout = (props: LayoutProps) => {
  const { children, ...otherProps } = props;

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      w="100%"
      h="100%"
      overflowX="hidden"
    >
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="flex-start"
        w="100%"
        h="100%"
        maxW="1920px"
        {...otherProps}
      >
        <Header />
        <NextNProgress color="#2D4FA7" nonce="5rTfmhMZEqh6Qtzt7BwS" />
        {children}
        <Footer />
      </Flex>
    </Flex>
  );
};

export default Layout;
